<template>
    <v-container class="container margin-top">

        <v-row class="mb-10">
            <v-btn v-if="false" color="accent" text small>
                <v-icon left>mdi-arrow-left</v-icon>
                {{ $t('common.back') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="accent" class="b1" text small :to="{name: 'login'}">
                {{ $t('entrance.login') }}
            </v-btn>
        </v-row>

        <v-row justify="center" align="center" v-if="isMobile">
            <v-sheet color="transparent">
                <v-img :src="imgPlaceholder" class="mx-auto mb-3" eager max-width="58"/>
                <div class="logo-title">{{ appName }}</div>
            </v-sheet>
        </v-row>

        <div class="mt-3 mb-10 h2">
            <b>{{ $t('entrance.create_user') }}</b>
        </div>

        <v-sheet color="transparent">
            <v-form v-model="valid">
                <v-row>
                    <v-col cols="12">
                        <kimsa-text-field
                            :label="$t('entrance.email')"
                            :placeholder="$t('entrance.email_placeholder')"
                            :rules="emailRules"
                            @change="email = $event"
                            :inputMode="'email'"
                        />
                    </v-col>

                    <v-col cols="12">
                        <kimsa-password-field
                            :label="$t('entrance.password')"
                            :placeholder="$t('entrance.password_placeholder')"
                            :rules="passwordRules"
                            @change="password = $event"
                            @enter="signUp"
                        />
                    </v-col>

                    <v-col cols="12">
                        <v-btn color="primary" depressed block large class="black--text b1"
                               :loading="loadingSignUp"
                               @click="signUp">
                            {{ $t('common.confirm') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-sheet>


    </v-container>
</template>

<script>

import KimsaTextField from "../common/inputs/KimsaTextField";
import KimsaPasswordField from "../common/inputs/KimsaPasswordField";

import {mapMutations} from 'vuex'

import firebase from 'firebase/app'
import "firebase/auth";
import {db} from "@/utils/Firebase";

export default {
    data(vm = this) {
        return {
            valid: false,
            email: '',
            password: '',
            loadingSignUp: false,
            emailRules: [
                v => !!v || vm.$t('rules.required'),
                v => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(v) || vm.$t('rules.invalid_email')
                }
            ],
            passwordRules: [
                v => !!v || vm.$t('rules.required'),
                v => v && v.length >= 6 || vm.$t('rules.min_length', {num: '6'})
            ],
        }
    },
    components: {
        KimsaTextField,
        KimsaPasswordField
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        async signUp() {
            const vm = this

            if (!vm.valid) return vm.showSnackBar({
                text: vm.$t('entrance.wrong_data'),
                color: 'error',
                closeColor: 'white'
            })
            vm.loadingSignUp = true

            await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
                .then(() => {
                    firebase.auth().createUserWithEmailAndPassword(vm.email, vm.password)
                        .then(async res => {
                            await res.user.sendEmailVerification()
                            const currentUser = firebase.auth().currentUser
                            let payload = {
                                email: currentUser.email,
                                rating: {count: 0, stars: 0}
                            }
                            if (vm.$route?.query?.type) payload.accountType = vm.$route.query.type || 'student'
                            await db.collection('users').doc(currentUser.uid).set(payload, {merge: true})
                            await vm.$store.dispatch('initUser', currentUser)
                            vm.$emit('success', currentUser)
                        })
                        .catch(error => {
                            let errorCode = error.code;
                            let errorMessage = error.message;
                            const message = errorCode === 'auth/email-already-in-use' ?
                                vm.$t('entrance.mail_already_exists') :
                                vm.$t('entrance.error_creating_account')

                            vm.showSnackBar({text: message, color: 'error', closeColor: 'white'})

                        })
                        .finally(function () {
                            vm.loadingSignUp = false
                        });
                })
                .catch(error => {
                    let errorCode = error.code;
                    let errorMessage = error.message;
                    const message = errorCode === 'auth/email-already-in-use' ?
                        vm.$t('entrance.mail_already_exists') :
                        vm.$t('entrance.error_creating_account')

                    vm.showSnackBar({text: message, color: 'error', closeColor: 'white'})
                })
        },
    },
}
</script>

<style scoped>

.label {
    font-size: 15px;
    color: #707070;
}

.little-label {
    font-size: 13px;
    color: #707070;
    text-align: center;
}

.separator {
    display: flex;
    align-items: center;
    text-align: center;
    color: #ccc;
    padding-top: 5px;
    padding-bottom: 5px;
}

.separator::before, .separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #ccc;
}

.separator::before {
    margin-right: 1.25em;
}

.separator::after {
    margin-left: 1.25em;
}

.container {
    padding-left: 10%;
    padding-right: 10%;
}

.margin-top {
    margin-top: 10%;
}

</style>
